import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, Redirect } from 'react-router-dom';
import moment from 'moment';

import {
  Container,
  TitlePage,
  Card,
  TitleCard,
  Order,
  TextStatus,
  DesktopDetails,
  CloseIcon,
  Details,
  Text,
  TitleDivision,
  BoxClose,
  BoxStatus,
  DetailsItems,
} from './styles';
import { StatusCollor } from '~/pages/GasVoucherList/styles';
import Loading from '~/components/layout/Loading';
import close from '~/assets/images/close.png';
import OpenChatBot from '~/components/layout/Chatbot';
import valegasicon from '~/assets/images/ic_vale_white.svg';
import { verifyRoles } from '~/utils/functions/verifyRoles';

export default function GasVoucherDetail() {
  const history = useHistory();

  const vouchersReducer = useSelector(state => state.vouchersReducer);
  const [loadingPage, _] = useState(false);
  const voucher = vouchersReducer.voucher;
  const roles = useSelector(state => state.rolesReducer.roles);

  return (
    <Container>
      {verifyRoles(roles, 'VALE_GAS') ? (
        <>
          <BoxClose>
            <TitlePage>
              <img src={valegasicon} alt="Ícone vale gás" />
              Vale gás
            </TitlePage>
            <div className="close">
              <CloseIcon
                src={close}
                alt="Ícone de fechar"
                onClick={() => history.push('/valegas')}
              />
            </div>
          </BoxClose>
          {loadingPage ? (
            <Loading loadingColor={'white'} />
          ) : (
            <Card>
              <DesktopDetails>
                <TitleCard>Código De Autorização</TitleCard>
                <Order>
                  <h4>{voucher.authorizationCode}</h4>
                </Order>
              </DesktopDetails>
              <Details>
                <BoxStatus>
                  <TitleCard>Status: </TitleCard>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <StatusCollor status={voucher.status} />
                    <TextStatus>{voucher.status}</TextStatus>
                  </div>
                </BoxStatus>
                <hr />
                <TitleDivision style={{ color: '#000FFF' }}>
                  Detalhes
                </TitleDivision>
                <div>
                  <DetailsItems>
                    <Text>
                      <strong>Tipo do Vale</strong>
                      <p>{voucher.voucherType}</p>
                    </Text>
                    {voucher.couponDate === '' ? null : (
                      <Text>
                        <strong>Data de compra</strong>
                        <p>
                          {moment(voucher.couponDate, 'YYYY-MM-DD').format(
                            'DD/MM/YYYY',
                          )}
                        </p>
                      </Text>
                    )}
                    <Text>
                      <strong>Data de bloqueio</strong>
                      <p>
                        { voucher.filterCode ? voucher.order.validationDate : moment(voucher.validationDate, 'YYYY-MM-DD').format(
                          'DD/MM/YYYY',
                        )}
                      </p>
                    </Text>
                    {voucher.status === 'Bonificado' ? (
                      <Text>
                        <strong>Data de bonificação do vale</strong>
                        <p>
                          {voucher.filterCode ? (voucher.bonus.bonusDate ? voucher.bonus.bonusDate : "") : moment(
                            voucher.bonificationDate,
                            'YYYY-MM-DD',
                          ).format('DD/MM/YYYY')}
                        </p>
                      </Text>
                    ) : null}
                    <Text>
                      <strong>Número do Vale</strong>
                      <p>{voucher.voucherNumber}</p>
                    </Text>
                    <Text>
                      <strong>Canal de bloqueio</strong>
                      <p>{voucher.filterCode ? voucher.order.validationChannel : voucher.validationChannel}</p>
                    </Text>
                    {voucher.filterCode ? null : (
                      voucher.deliveryInvoice !== 0 ? (
                        <Text>
                          <strong>NF de remessa</strong>
                          <p>{voucher.deliveryInvoice}</p>
                        </Text>
                      ) : null
                    )
                    }
                    <Text>
                      <strong>Código do produto</strong>
                      <p>{voucher.filterCode ? voucher.product.codeProduct : voucher.product.code}</p>
                    </Text>
                    <Text>
                      <strong>Descrição do produto</strong>
                      <p>{voucher.filterCode ? voucher.product.descriptionProduct : voucher.product.description}</p>
                    </Text>
                  </DetailsItems>
                </div>
                <div>
                  <Text className="w-100" withoutMobile>
                    <strong>Local de compra do Vale</strong>
                    <p>
                      {voucher.filterCode ? voucher.distributor.nameDistributor : voucher.distributor.name} - {voucher.filterCode ? voucher.distributor.addressDistributor : voucher.distributor.address}
                    </p>
                  </Text>
                </div>
              </Details>
            </Card>
          )}
        </>
      ) : (
        <Redirect to="/portal" />
      )}
      <OpenChatBot />
    </Container>
  );
}
